import styled from 'styled-components';

export const Container = styled.div`
  flex: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;

  > * {
    flex: 1;
  }
`;
